import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Box, Typography } from "@mui/material";

import QRWithLogo from "../QRWithLogo";
import CustomFooterImage from "./CustomFooterImage";
import { t } from "../../../../components/translate";
import { getSectionStyle } from "../LabPrintFunctions";
import { getTestReportBaseUrl } from "../../../../helpers/urls";
import useCurrentResourceCentre from "../../../../hooks/useCurrentResourceCentre";

// @ts-expect-error - svg
import logo from "../../../../../assets/images/poweredByOkhati1.svg";

interface LabPrintFooterProps {
  unfixFooter?: boolean;
  uuid: string;
  headerColor: string;
  showFooter: boolean;
  hideFooterLogoCompletely: boolean;
  showQRCode?: boolean;
}

const LabPrintFooter: React.FC<LabPrintFooterProps> = ({
  unfixFooter = false,
  uuid,
  headerColor,
  showFooter,
  hideFooterLogoCompletely,
  showQRCode = false
}) => {
  const resourceCentre = useCurrentResourceCentre();
  const customFooterImage = resourceCentre?.labSettings?.customFooterImage;

  return (
    <>
      {showFooter && (
        <Box component="div" width="100%" className={unfixFooter ? "" : "billFooterPos"} mb="-12pt">
          {customFooterImage ? (
            <Box
              paddingTop="0.5rem"
              style={{ ...getSectionStyle(headerColor).footerStyle, paddingBottom: "1rem" }}
            >
              <CustomFooterImage imageUrl={customFooterImage} />
            </Box>
          ) : (
            <Box
              paddingTop="0.5rem"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              style={{ ...getSectionStyle(headerColor).footerStyle }}
            >
              <Box component="span">
                <Box display="flex" justifyContent="space-between">
                  <QRCodeSVG size={60} value={`${getTestReportBaseUrl()}/${uuid}`} />
                  <Box ml="8px">
                    <Typography sx={{ maxWidth: "110px", fontSize: "0.8rem" }}>
                      {t("labPrint.qrUrlFooter")}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box component="div">
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    width: "100px",
                    height: "33px"
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
      )}

      {!showFooter && (
        <Box width="100%" className={unfixFooter ? "" : "billFooterPos"}>
          {showQRCode ? (
            <QRWithLogo uuid={uuid} hideFooterCompletely={hideFooterLogoCompletely} />
          ) : (
            <Box display="flex" justifyContent="flex-end" mb={-1} paddingRight="10mm">
              {!hideFooterLogoCompletely && (
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    width: "100px",
                    height: "33px"
                  }}
                />
              )}
            </Box>
          )}
          <Box height="3.5cm" />
        </Box>
      )}
    </>
  );
};

export default LabPrintFooter;
